import { useBboxToggles } from "../hooks/useBboxToggles";
import "./bbox-legend.css";

/**
 * R-139 / Phase 1.5 — the Boxes overlay toggle moved from a floating
 * toolbar inside `.vs-document` to a header-docked button next to
 * `BboxLegendHeaderButton`. Same hook (`useBboxToggles`), same keyboard
 * shortcut (`B`); only the chrome changed.
 *
 * VerificationStation mounts `BboxOverlayHeaderButton` directly. (The legacy
 * no-op `BboxOverlayToolbar` shim was pruned in Wave F once its last importer
 * was gone.)
 */
export function BboxOverlayHeaderButton() {
  const { showBboxOverlays, toggleBboxOverlays } = useBboxToggles();

  return (
    <button
      type="button"
      className="vs-detach-btn"
      aria-pressed={showBboxOverlays}
      aria-label="Bbox overlays"
      data-testid="bbox-overlay-toggle"
      title="Toggle bbox overlays (B)"
      onClick={toggleBboxOverlays}
    >
      {showBboxOverlays ? "Hide Boxes" : "Boxes"}
    </button>
  );
}
